module.exports = __webpack_public_path__ + "img/Brit Blalock.9d64ed0f.jpg";